import { Input, Directive, HostBinding, input, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
@Directive()
export class DmsBaseFolderAction {
  protected readonly translateService = inject(TranslateService);

  readonly folderId = input<string>();
  readonly folderId$ = toObservable(this.folderId);
  @Input() labelOnly = false;
  @Input() iconOnly = false;
  @Input() cssClass: string;

  @Input() set disabled(value: boolean) {
    this._disabled = value;
    this.setDisabled(value);
  }
  get disabled(): boolean {
    return this._disabled;
  }

  protected _disabled = false;

  @HostBinding('class.action-button')
  @Input() isFileAction = true;

  @HostBinding('class.mat-mdc-menu-item')
  @HostBinding('class.is-mat-mdc-menu')
  @Input() isMatMenu = true;

  get btnClass(): string {
    return this.cssClass;
  }

  get label(): string {
    return this._label;
  }

  get title(): string {
    return this.translateService.instant(this.label);
  }

  protected _label: string;

  @HostBinding('class.disabled-action-button') isFileActionDisabled = false;

  public setDisabled(isDisabled: boolean): void {
    this.isFileActionDisabled = isDisabled;
  }
}
